<template>
  <div style="overflow: hidden;" id="app">
    <div style="display: flex; flex-direction: row; height: 100%; ">
      <div
        v-if="device === 'mobile' && !isCollapse"
        style="position: relative; min-width: 210px;"
        class="sidebar-container mobile"
      >
        <el-row class="rowTop">
          <span
            style="width: 100%; text-align: left; color: #000; font-size: 18px; font-weight: normal;"
            >Hi, {{ username }}</span
          >
        </el-row>
        <el-row class="rowTop4">
          <div
            style="display: flex; width: 100%; justify-content: center; align-items: flex-start; flex-direction: column; margin-bottom: 4px;"
          >
            <el-button @click="() => switchCompany()" type="primary" size="mini"
              >Switch Branch</el-button
            >
          </div>
          <div
            style="display: flex; flex-direction: column; width: 100%;"
            v-if="branchData"
          >
            <span
              v-if="branchData.regionId"
              style="width: 100%; text-align: left; color: #000; font-size: 14px; margin-bottom: 4px; margin-top: 4px;"
              >{{ branchData.regionId.companyId && branchData.regionId.companyId.name ? branchData.regionId.companyId.name : "-" }}</span
            >
            <span
              v-if="branchData.relation"
              style="width: 100%; text-align: left; color: #000; font-size: 14px; margin-bottom: 4px; margin-top: 4px;"
              >{{ branchData.relation.role }}</span
            >
            <!-- <span
              v-if="branchData.region"
              style="width: 100%; text-align: left; color: #000; font-size: 14px; margin-bottom: 4px;"
              >{{ branchData.region.name }}</span
            >
            <span
              style="width: 100%; text-align: left; color: #000; font-size: 14px;"
              >{{ branchData.name }}</span
            > -->
          </div>
        </el-row>
        <el-scrollbar wrapClass="scrollbar-wrapper">
          <el-menu
            mode="vertical"
            :show-timeout="200"
            :default-active="$route.path"
            :collapse="isCollapse"
            style="height: auto;"
          >
            <sidebar-item :routes="permission_routers"></sidebar-item>
          </el-menu>
          <el-menu
            mode="vertical"
            :show-timeout="200"
            :default-active="$route.path"
            :collapse="isCollapse"
            style="height: auto;"
          >
            <div class="menu-wrapper">
              <template>
                <div v-if="branchSelected" @click="projectLeave()">
                  <el-menu-item
                    index="/projects"
                    :class="{ 'submenu-title-noDropdown': true }"
                  >
                    <i class="el-icon-back"></i>
                    <span slot="title">
                      Projects
                    </span>
                  </el-menu-item>
                </div>
                <el-menu-item
                  index="/logout"
                  @click="logout"
                  class="submenu-title-noDropdown"
                >
                  <i style="color: #000;" class="el-icon-switch-button"></i>
                  <span slot="title">Log Out</span>
                </el-menu-item>
              </template>
            </div>
          </el-menu>
        </el-scrollbar>
      </div>
      <div
        :style="
          device === 'mobile' && globalSidebar === true
            ? 'left: 180px; position: absolute;'
            : ''
        "
        style="display: flex; flex-direction: column; height: 100%; width: 100%;"
      >
        <header v-if="burgerAllowed" style="height: 65px;">
          <div class="headerClass">
            <div
              style="display: flex; flex: 1; align-items: center; justify-content: flex-start; flex-direction: row;"
            >
              <!-- <span>{{ branchLogo.toString() }}</span> -->
              <a href="/" v-if="logo !== null">
                <img class="appLogo" :src="logo ? branchLogo : colorMode ? coloredLogo : defaultLogo" />
                <!-- <span style="color: #fff; font-size: 28px; font-weight: bold;">ITXCRADLEAI</span> -->
              </a>
            </div>
            <nav
              v-if="device !== 'mobile'"
              style="flex: 2; display: flex; justify-content: flex-start; align-items: center;"
            >
              <div style="width: 100%;">
                <ul
                  style="display: flex; list-style: none; margin: 0; padding: 0; flex-direction: row; flex-wrap: wrap;"
                >
                  <!-- <li style="padding: 0; flex: 1;">
                    <a href="/" class="headerLink">HOME</a>
                  </li> -->
                </ul>
              </div>
            </nav>
            <div
              v-if="token === '' && device !== 'mobile'"
              style="flex: 1; display: flex; flex-direction: row; align-items: center; justify-content: center;"
            ></div>
            <div
              v-else-if="device !== 'mobile'"
              style="flex: 1; display: flex; flex-direction: row; align-items: center; justify-content: center;"
            >
              <el-dropdown style="margin-left: 10px;" trigger="click">
                <span
                  class="primaryTextColor"
                  style="display: flex; flex-direction: row; justify-content: center; align-items: center; cursor: pointer;"
                >
                  <!-- <i class="el-icon-user-solid"></i> -->
                  <img
                    v-if="profilePicture"
                    style="display: flex; width: 35px; height: 35px; margin-right: 12px;"
                    :src="profilePicture"
                  />
                  <div
                    v-else
                    style="display: flex; width: 35px; height: 35px; margin-right: 12px; background-color: #000;"
                  ></div>
                  <span style="display: flex; width: 100%; height: 100%;"
                    >{{ awakRole !== "none" ? username : username }}
                    <i class="el-icon-caret-bottom"></i
                  ></span>
                </span>
                <el-dropdown-menu class="user-dropdown" slot="dropdown">
                  <el-dropdown-item>
                    <span @click="logout" style="display:block;">Log Out</span>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <span
                class="colorModeDiv"
              >
                <svg-icon icon-class="sun" :class="!tempColorMode ? 'active' : ''" />
                <el-switch
                  :value="tempColorMode"
                  @change="toggleColorMode"
                  style="margin-left: 5px; margin-right: 5px;"
                  active-color="#00FF41"
                  inactive-color="#DCDFE6">
                </el-switch>
                <svg-icon icon-class="moon" :class="tempColorMode ? 'active' : ''" />
              </span>
            </div>
            <hamburger
              v-if="device === 'mobile'"
              style="position: relative; display: flex; flex-direction: row;"
              class="hamburger-container"
              :toggleClick="toggleGlobalSideBar"
              :isActive="globalSidebar.opened"
            ></hamburger>
          </div>
        </header>
        <div ref="routerParent" @click="handleClickOutside()" style="display: flex; width: 100vw; height: 100vh;">
          <router-view :switchCompany="switchCompany" :nextBranch="nextBranch"></router-view>
        </div>
      </div>
    </div>
    <el-dialog
      title="Switch Company Branch"
      :visible.sync="userBranch"
      :before-close="resetForm"
    >
      <div style="display: flex; flex-direction: row; width: 100%; padding-left: 2px; padding-right: 2px;">
        <el-input class="border2px" placeholder="Search" style="width: 100%; margin-left: 0px;" @change="()=>searchBranch()" v-model="branchSearch">
          <i slot="suffix" class="el-input__icon el-icon-search"></i>
        </el-input>
      </div>
      <div style="display: flex; flex-direction: row; justify-content: flex-start; align-items: center; flex-wrap: wrap; overflow: hidden; padding-left: 0px; padding-right: 0px; padding-top: 10px;" v-if="!branchLoading">
        <el-button class="tagButton" :style="`background-color: ${currUser2.company === item._id ? 'var(--dark-font)' : 'rgba(0,0,0,0)'}; color: ${currUser2.company === item._id ? 'var(--primary4-color)' : 'var(--dark-font)'};`" v-for="(item, key) in filteredCompanies" :key="key" @click="()=>{
            if (currUser2.company !== item._id) {
              currUser2.company = item._id;
              currUser2.region = 0;
              currUser2.branch = 0;
              selectBranch()
            }
          }">
          {{ item.relationId ? item.relationId.name : '-' }}
        </el-button>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="resetForm">Cancel</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Hamburger from "@/components/Hamburger";
import { mapGetters } from "vuex";
import defaultLogo from "./assets/icon_mayor.png";
import coloredLogo from "./assets/icon_mayor.png";
import maidCharacter from "./assets/meticulousmaid-cartoon1.png"
import kaedeCharacter from "./assets/kaede.png"
import plutoCharacter from "./assets/plutoCharacter.png"
// import sun from './icons/svg/sun.svg'
// import moon from './icons/svg/moon.svg'
import "@/permission";
import ResizeMixin from "@/mixin/ResizeHandler";
import moment from "moment";
import Cookies from 'js-cookie'
// import SocketIO from 'socket.io-client'

export default {
  name: "App",
  components: { Hamburger },
  mixins: [ResizeMixin],
  data() {
    return {
      title: process.env.APP_NAME.toUpperCase(),
      appname: process.env.APP_NAME,
      currUser2: {
        company: null,
        region: 0,
        branch: 0
      },
      logo: null,
      year: "",
      filteredCompanies: [],
      automaidCommands: [
        {
          label: "New Branch",
          commandCode: "general.newBranch"
        }
      ],
      branchSearch: "",
      branchLoading: false,
      // notificationSocket: null,
      signInLoading: false,
      agePermission: false,
      userBranch: false,
      // colorMode: false,
      refreshPageAfter: false,
      defaultLogo,
      coloredLogo,
      tempColorMode: false,
      automaidShow: false,
      automaidMessage: "",
      automaidCharacterImage: plutoCharacter,
      // automaidGreetingList: ["How may I assist you today?", "What can I help you with?", "How may I serve you?"],
      automaidGreetingList: ["Good day boss. What can I help you with?", "Your wish is my command, boss.", "Hey boss. How can I help you today?"],
      maidCharacter,
      kaedeCharacter
      // sun,
      // moon
    };
  },
  methods: {
    changeColor(color){
      if (color) {
      // document.documentElement.style.setProperty('--bg-color', "#111111");
      // document.documentElement.style.setProperty('--bg2-color', "#000000");
      // document.documentElement.style.setProperty('--bg3-color', "rgba(51,51,51,.9)");
      // document.documentElement.style.setProperty('--bg4-color', "#222222");
      // document.documentElement.style.setProperty('--bg5-color', "#333333");
      // document.documentElement.style.setProperty('--bg6-color', "#00FF41");
      // document.documentElement.style.setProperty('--bg7-color', "#666666");
      // document.documentElement.style.setProperty('--bg8-color', "#111111");
      // document.documentElement.style.setProperty('--bg9-color', "#353535");
      // document.documentElement.style.setProperty('--bg10-color', "#111111");
      // document.documentElement.style.setProperty('--bg11-color', "#00FF41");
      // document.documentElement.style.setProperty('--bg12-color', "#000000");
      // document.documentElement.style.setProperty('--bg13-color', "#000000");
      // document.documentElement.style.setProperty('--primary-color', "#00FF41");
      // document.documentElement.style.setProperty('--primary2-color', "#000000");
      // document.documentElement.style.setProperty('--primary3-color', "#ffffff");
      // document.documentElement.style.setProperty('--primary4-color', "#00FF41");
      // document.documentElement.style.setProperty('--primary5-color', "#00FF41");
      // document.documentElement.style.setProperty('--primary6-color', "#00FF41");
      // document.documentElement.style.setProperty('--primary7-color', "#2caa4a");
      // document.documentElement.style.setProperty('--primary8-color', "#00FF41");
      // document.documentElement.style.setProperty('--primary9-color', "#000000");
      // document.documentElement.style.setProperty('--primary10-color', "#000000");
      // document.documentElement.style.setProperty('--primary11-color', "#000000");
      // document.documentElement.style.setProperty('--secondary1-active-color', "#00FF41");
      // document.documentElement.style.setProperty('--secondary1-inactive-color', "#00FF41");
      // document.documentElement.style.setProperty('--secondary2-active-color', "#00FF41");
      // document.documentElement.style.setProperty('--secondary2-inactive-color', "#00FF41");
      // document.documentElement.style.setProperty('--secondary3-active-color', "#00FF41");
      // document.documentElement.style.setProperty('--secondary3-inactive-color', "#DCDFE6");
      // document.documentElement.style.setProperty('--secondary4-active-color', "#111111");
      // document.documentElement.style.setProperty('--secondary4-inactive-color', "#00FF41");
      // document.documentElement.style.setProperty('--secondary5-active-color', "#2caa4a");
      // document.documentElement.style.setProperty('--secondary5-inactive-color', "#2caa4a");
      // document.documentElement.style.setProperty('--secondary6-active-color', "#2e6555");
      // document.documentElement.style.setProperty('--secondary6-inactive-color', "#00FF41");
      // document.documentElement.style.setProperty('--table-border-color', "#333333");
      // document.documentElement.style.setProperty('--beigeToGray', "#909399");
    } else {
      // document.documentElement.style.setProperty('--bg-color', "#FFFAEB");
      // document.documentElement.style.setProperty('--bg2-color', "#FFFDF7");
      // document.documentElement.style.setProperty('--bg3-color', "rgba(255,255,255,.9)");
      // document.documentElement.style.setProperty('--bg4-color', "#EEEEEE");
      // document.documentElement.style.setProperty('--bg5-color', "#FFFAEB");
      // document.documentElement.style.setProperty('--bg6-color', "#dbbc77");
      // document.documentElement.style.setProperty('--bg7-color', "#ffffff");
      // document.documentElement.style.setProperty('--bg8-color', "#ebe0c9");
      // document.documentElement.style.setProperty('--bg9-color', "#FFFAEB");
      // document.documentElement.style.setProperty('--bg10-color', "#FFFAEB");
      // document.documentElement.style.setProperty('--bg11-color', "#4F3932");
      // document.documentElement.style.setProperty('--bg12-color', "#4F3932");
      // document.documentElement.style.setProperty('--bg13-color', "#F3DAA2");
      // document.documentElement.style.setProperty('--primary-color', "#000000");
      // document.documentElement.style.setProperty('--primary2-color', "#ffffff");
      // document.documentElement.style.setProperty('--primary3-color', "#000000");
      // document.documentElement.style.setProperty('--primary4-color', "#F3DAA2");
      // document.documentElement.style.setProperty('--primary5-color', "#619571");
      // document.documentElement.style.setProperty('--primary6-color', "#ffffff");
      // document.documentElement.style.setProperty('--primary7-color', "#ffffff");
      // document.documentElement.style.setProperty('--primary8-color', "#783f04");
      // document.documentElement.style.setProperty('--primary9-color', "#619571");
      // document.documentElement.style.setProperty('--primary10-color', "#F3DAA2");
      // document.documentElement.style.setProperty('--primary11-color', "#783f04");
      // document.documentElement.style.setProperty('--secondary1-active-color', "#C0C4CC");
      // document.documentElement.style.setProperty('--secondary1-inactive-color', "#303133");
      // document.documentElement.style.setProperty('--secondary2-active-color', "#909399");
      // document.documentElement.style.setProperty('--secondary2-inactive-color', "#606266");
      // document.documentElement.style.setProperty('--secondary3-active-color', "#000000");
      // document.documentElement.style.setProperty('--secondary3-inactive-color', "#DCDFE6");
      // document.documentElement.style.setProperty('--secondary4-active-color', "#FFFDF7");
      // document.documentElement.style.setProperty('--secondary4-inactive-color', "#FFFAEB");
      // document.documentElement.style.setProperty('--secondary5-active-color', "#dbbc77");
      // document.documentElement.style.setProperty('--secondary5-inactive-color', "#fffdf7");
      // document.documentElement.style.setProperty('--secondary6-active-color', "#dbbc77");
      // document.documentElement.style.setProperty('--secondary6-inactive-color', "#dbbc77");
      // document.documentElement.style.setProperty('--table-border-color', "#EBEEF5");
      // document.documentElement.style.setProperty('--beigeToGray', "#F3DAA2");
    }
    },

    toggleGlobalSideBar() {
      this.$store.dispatch("ToggleGlobalSideBar");
    },
    toggleColorMode() {
      this.$store.dispatch("ToggleColorMode");
      this.tempColorMode = !this.tempColorMode
    },
    // login() {
    //   this.$router.push('/login')
    // },
    // register() {
    //   this.$router.push('/register')
    // },
    // dashboard() {
    //   this.$router.push('/dashboard')
    // },
    signIn() {
      this.$store.dispatch("OpenSignInPopup", { subscribe: false });
    },
    signInClose() {
      this.$store.dispatch("CloseSignInPopup");
    },
    branchLeave() {
      this.$store.dispatch("SetBranchSelected", null).then(() => {
        this.$store.dispatch("ClearRoutes").then(() => {
          this.$router.push("/projects");
        });
      });
    },
    logout() {
      this.$store.dispatch("LogOut").then(() => {
        this.$store.dispatch("ResetRoutes").then(() => {
          this.$router.push("/?logout=true");
        });
      });
    },
    handleClickOutside() {
      this.$store.dispatch("CloseGlobalSideBar", { withoutAnimation: false });
    },
    google() {
      if (this.agePermission) {
        this.signInLoading = true;
      }
    },
    kick(route) {
      this.$router.push(route);
    },
    legal() {
      window.open('/legal')
    },
    privacy() {
      window.open('/privacy')
    },
    cookie() {
      window.open('/cookie')
    },
    searchBranch() {
      // console.log(this.branchSearch)
      // console.log(this.companies)
      this.branchLoading = true;
      this.filteredCompanies = this.companies.filter((company) => {
        return company && company.relationId && company.relationId.name ? company.relationId.name.toLowerCase().includes(this.branchSearch.toLowerCase()) : false;
      });
      // console.log(this.filteredCompanies)
      this.$nextTick(() => {
        this.branchLoading = false;
      })
    },
    resetForm() {
      this.userBranch = false;
      // this.currUser2 = {
      //   company: null,
      //   region: 0,
      //   branch: 0
      // }
    },
    async selectBranch() {
      // this.$store
      //   .dispatch(
      //     "SetBranchSelected",
      //     this.companies[this.currUser2.company].relationId.regions[this.currUser2.region]
      //       .branches[this.currUser2.branch]._id
      //   )
      //   .then(() => {
      //     // this.$store.dispatch("ClearRoutes").then(() => {
      //     //   this.$router.push("/bookings");
      //     // });
      //     location.reload();
      //     // this.$router.push("/");
      //   });
      this.userBranch = false;
			const index = this.filteredCompanies.findIndex((v) =>  v._id === this.currUser2.company)
      this.$router.push(`/z/${
        this.filteredCompanies[index].relationId.regions[this.currUser2.region]
          .branches[this.currUser2.branch]._id
      }/default?refresh=1`)
      // this.refreshPageAfter = true
      // this.$router.push('/account?refresh=true')
      this.currUser2 = {
        company: null,
        region: 0,
        branch: 0
      }
      // this.$router.push('/account')
      // location.reload();
    },
    nextBranch() {
      const companies = this.filteredCompanies
      let key = this.currUser2.company
      let item = null
      
      if (companies.length > 0) {
        // console.log("App Before")
        // console.log(this.$store.state.app.branchSelected)
        key = key + 1
        if (key == companies.length) {
          key = 0
        }
        item = companies[key]
        // console.log(item.relationId.regions[this.currUser2.region]
        //       .branches[this.currUser2.branch]._id)
        // console.log(servers)
        // console.log(key)
        // console.log(item)
        this.$store
          .dispatch(
            "GetBranch",
            companies[key].relationId.regions[this.currUser2.region]
              .branches[this.currUser2.branch]._id
          )
        // console.log("App After")
        // console.log(this.$store.state.app.branchSelected)
        this.currUser2.company = key
        // console.log("switch")
        // console.log(companies)
        // console.log(key)
        // console.log(item)
        // console.log(this.$store.state.user.branchData)
        return item.relationId.regions[this.currUser2.region]
              .branches[this.currUser2.branch]._id
      }
      return null
      // console.log("switch")
    },
    switchCompany() {
      this.userBranch = true;
      // console.log("this.filteredCompanies", this.filteredCompanies)
      if (this.filteredCompanies && this.filteredCompanies.length > 0 && this.$store.state.user.branchData) {
				const index = this.filteredCompanies.findIndex((v) => this.$store.state.user.branchData.relation && v._id === this.$store.state.user.branchData.relation._id)
				// console.log(index)
        this.currUser2.company = index !== null ? this.filteredCompanies[index]._id : null
				// console.log(this.currUser2.company)
      }
      // console.log("this.currUser2.company", this.currUser2.company)
    },
    showAutomaid() {
      if (this.automaidShow === false) {
        // based on automaidGreetingList, choose a random greeting
        const randomGreeting = this.automaidGreetingList[Math.floor(Math.random() * this.automaidGreetingList.length)]
        this.automaidMessage = randomGreeting
      }
      this.automaidShow = !this.automaidShow
    },
    log(key, message) {
      console.log(key, message)
    }
  },
  computed: {
    username() {
      return this.$store.state.user.username;
    },
    token() {
      return this.$store.state.user.token;
    },
    companies() {
      return this.$store.state.user.companies.sort((a, b) => {
        if (a.relationId && b.relationId) {
          if (a.relationId.name < b.relationId.name) {
            return -1
          }
          if (a.relationId.name > b.relationId.name) {
            return 1
          }
        }

        return 0
      });
    },
    globalSidebar() {
      return this.$store.state.app.globalSidebar;
    },
    branchData() {
      return this.$store.state.user.branchData
        ? this.$store.state.user.branchData
        : {};
    },
    branchLogo() {
      return this.$store.state.user.branchLogo;
    },
    features() {
      return this.$store.state.user.features;
    },
    branchSelected() {
      return this.$store.state.app.branchSelected;
    },
    signInPopup() {
      return this.$store.state.app.signInPopup;
    },
    device() {
      return this.$store.state.app.device;
    },
    isCollapse() {
      return !this.$store.state.app.globalSidebar.opened;
    },
    burgerAllowed() {
      return this.$store.state.app.burgerAllowed;
    },
    awakRole() {
      return this.$store.state.user.awakRole;
    },
    userData() {
      return this.$store.state.user.userData;
    },
    profilePicture() {
      return this.$store.state.user.profilePicture;
    },
    colorMode() {
      return this.$store.state.app.colorMode;
    },
    ...mapGetters(["permission_routers"])
  },
  filters: {
    roleFilter(val) {
      if (val !== "none") {
        return val[0].toUpperCase() + val.substring(1);
      } else {
        return "Manager";
      }
    }
  },
  mounted() {
    // console.log('app branchSelected', this.$store.state.app.branchSelected)
    this.year = moment().format("YYYY");
    this.logo = null
    this.filteredCompanies = this.companies

    this.tempColorMode = this.colorMode === 1 ? true : false;

    this.changeColor(this.colorMode);

    // console.log("branchData", this.branchData)
    // if (this.branchData.logo) {
    //   this.logo = this.branchData.logo.path
    // }
    // console.log("branchData2", this.$store.state.user.branchData
    //     ? this.$store.state.user.branchData
    //     : {})
    // this.colorMode = false
    // console.log(this.$store.state.user.features)
    // if (this.$store.state.app.branchSelected) {
    //   this.notificationSocket = SocketIO.connect(process.env.BASE_API, {
    //     path: '/serviceNotifications-admin-socket.io',
    //     query: `token=${this.token}`
    //   })
    //   this.notificationSocket.on('connect', () => {
    //     console.log('connected')
    //     this.notificationSocket.emit('join', this.$store.state.app.branchSelected)
    //   })
    //   this.notificationSocket.on('newNotification', (data) => {
    //     console.log('app', data)
    //     this.$store.dispatch('GetUnreadMessages', this.$store.state.app.branchSelected)
    //   })
    // }
    // console.log(typeof this.notificationSocket)
    // console.log("company", this.currUser2.company)
    // console.log("branchData", this.$store.state.user.branchData)
    // console.log("filteredCompanies", this.filteredCompanies)
    // console.log("companies", this.companies)
  },
  // destroyed() {
  //   this.notificationSocket.disconnect()
  // },
  watch: {
    colorMode(to, from) {
      this.changeColor(to);
    },
    branchLogo(to, from){
      this.logo = to
    }
  },
  beforeRouteLeave(to, from, next) {
    this.$Tawk.$endChat();
    // console.log("beforeRouteLeave", to, from, next)
    // console.log(this.refreshPageAfter)
    // if (this.refreshPageAfter) {
    //   next(() => {
    //     location.reload();
    //   });
    // }
  }
};
</script>

<style lang="scss">
@import "./styles/variables.scss";
@font-face {
  font-family: College;
  src: url("./fonts/college/college.ttf");
}
@font-face {
  font-family: College;
  font-weight: bold;
  src: url("./fonts/college/collegeb.ttf");
}
@font-face {
  font-family: CaviarDreams;
  src: url("./fonts/caviar_dreams/CaviarDreams.ttf");
}
@font-face {
  font-family: CaviarDreams;
  font-weight: bold;
  src: url("./fonts/caviar_dreams/CaviarDreams_Bold.ttf");
}

.Cookie--xfero {
  background-color: var(--container-subtle-fill);
  color: var(--dark-font);
  backdrop-filter: blur(10px);
  padding: 1.25em;
}
.Cookie--xfero .Cookie__button {
  border-radius: 28px;
  background: var(--el-button2-mid);
  padding: 0.625em 3.125em;
  color: var(--el-button2-font);
  border: 0;
  font-size: 1em;
  font-family: 'PublicaSans', sans-serif;
}
.Cookie--xfero .Cookie__button:hover {
  background: var(--el-button2-mid);
}
.Cookie--xfero .Cookie__button:focus {
  background: var(--el-button2-mid);
}

.appLogo {
  max-height: 50px;
  max-width: 320px;
}

h1 {
  color: $color1;
}

.normal-text {
  color: #000;
  padding: 20px 2%;
}

.hyperlink {
  color: cyan;
}

.Cookie--dark-lime {
  background-color: #fff;
  color: #000;
}
.Cookie--dark-lime .Cookie__button {
  background-color: #409eff;
  border: 1px solid #dcdfe6;
  box-sizing: border-box;
  border-radius: 4px;
}
.Cookie--dark-lime .Cookie__button:hover {
  background-color: #409eff;
  border: 1px solid #dcdfe6;
  box-sizing: border-box;
  border-radius: 4px;
}
.Cookie--dark-lime .Cookie__button:focus {
  background-color: #409eff;
  border: 1px solid #dcdfe6;
  box-sizing: border-box;
  border-radius: 4px;
}

.headerClass {
  border-bottom-width: 1px;
  border-bottom-color: rgba(0, 0, 0, 0.2);
  border-bottom-style: solid;
  height: 65px;
  padding: 0px 10%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  // background-color: var(--bg10-color);
  background-position: center;
  // background-repeat: no-repeat;
  background-size: 60px 60px;
  background-image: url('./assets/sportloopstarlight.png');
  .headerLink {
    display: block;
    font-size: 18px;
    color: var(--dark-font);
    padding-top: 15px;
    padding-right: 0px;
    padding-bottom: 16px;
    padding-left: 0px;
    text-align: center;
  }
}

.titleColor {
  color: $color1;
}
.titleColor:focus {
  color: $color1;
}
.titleColor:hover {
  color: $color1;
}
.rowTop {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0px 20px;
  height: 56px;
  background-color: var(--bg-color);
}

.rowTop4 {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 0px 20px;
  height: 96px;
  background-color: var(--bg-color);
}

.companyList {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 50%;
  background-color: var(--bg-color);
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 10px;
  padding-bottom: 10px;
  .companyButton {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    border-radius: 2px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
    box-sizing: border-box;
    padding-left: 10px;
    padding-right: 10px;
    padding-top: 10px;
    padding-bottom: 10px;
    p {
      text-align: center;
    }
  }
  .companyButton:hover {
    box-shadow: 0 1px 8px rgba(0, 0, 0, 0.3);
  }
  .companyButton.inactive {
    border: 1px solid var(--primary4-color);
    background-color: var(--bg-color);
    color: var(--secondary2-inactive-color);
    cursor: pointer;
  }
  .companyButton.active {
    border: 1px solid var(--primary5-color);
    background-color: var(--primary5-color);
    color: var(--primary2-color);
    cursor: inherit;
  }
}

.colorModeDiv {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  color: var(--secondary3-inactive-color);
  position: absolute;
  right: 20px;
  .active {
    color: var(--secondary3-active-color);
  }
}
.border2px {
  input {
    border-width: 2px;
  }
}
::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #f0f;
}


.footerClass {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  color: var(--dark-font);
  background-color: var(--bg-color);
  border-top: 1px solid #aaa;
  padding: 2px 0px;
}
.footer2Class {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: var(--dark-font);
  background-color: var(--bg-color);
  border-top: 1px solid #aaa;
  padding: 10px 10px;
}

.selectBackground {
  .el-input__inner {
    background-color: var(--bg-color);
  }
}

.tagButton {
  display: flex; justify-content: center; align-items: center; border-width: 1.5px !important; height: 40px; margin-left: 2px !important; margin-right: 2px; margin-bottom: 10px; font-size: 12px;
}
.automaidOverlay {
  position: absolute;
  z-index: 1002;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  .characterContainer {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: flex-end;
    position: absolute;
    z-index: 1004;
    right: 20px;
    bottom: 80px;
    img {
      display: flex;
      width: 160px;
      height: 160px;
      border-radius: 50%;
      object-fit: cover;
      // object-fit: contain;
    }
    .messageContainer {
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      align-items: center;
      color: var(--primary2-color);
      // background-color: var(--bg6-color);
      position: absolute;
      z-index: 1003;
      width: 320px;
      height: 240px;
      top: -240px;
      p {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        text-align: center;
        padding: 10px 10px;
        margin: 0px;
        font-size: 32px;
        background-color: rgba(0, 0, 0, 0.2);
      }
    }
  }
  .responseContainer {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: var(--primary2-color);
    // background-color: var(--bg6-color);
    position: absolute;
    z-index: 1003;
    width: 100%;
    height: 50vh;
    bottom: 0px;
    p {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      text-align: center;
      padding: 10px 10px;
      font-size: 32px;
      background-color: rgba(0, 0, 0, 0.2);
    }
  }
}
.automaidOverlay.hide {
  visibility: hidden;
  opacity: 0;
  background-color: rgba(0, 0, 0, 0);
  transition: visibility 0s, opacity 0.2s linear;
  transition-delay: 0.2s, 0s;
  transition-property: visibility, opacity;
}
.automaidOverlay.show {
  visibility: visible;
  opacity: 1;
  background-color: rgba(0, 0, 0, 0.5);
  transition: visibility 0s, opacity 0.2s linear;
}
.automaidButton {
  display: flex;
  position: absolute;
  z-index: 1010;
  width: 40px;
  height: 40px;
  bottom: 20px;
  right: 20px;
  padding: 0px;
  justify-content: center;
  align-items: center;
  // color: var(--primary2-color);
  // background-color: var(--bg6-color);
}
</style>


// WEBPACK FOOTER //
// src/App.vue